import { router } from '../util/router'
import 'lightgallery.js'

router.on('common', 'init', () => {

  /* global lightGallery */
  lightGallery($('.gallery')[0], {
    selector: '.item',
    download: false,
  });
})



// WEBPACK FOOTER //
// ./scripts/components/lightgallery.js